import React from 'react';

import { KeyFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';

import { DEFAULT_STAFF_ROLE_ICON_COLOR } from '../../consts';

export default function StaffRoleIcon({
  className,
  size = 20,
  tagColor,
}: {
  className?: string;
  size?: number;
  tagColor?: string | null;
}) {
  return (
    <KeyFill
      className={cn(`w-${size} h-${size}`, className)}
      style={{ color: tagColor || DEFAULT_STAFF_ROLE_ICON_COLOR }}
    />
  );
}
